<template>
    <el-dialog title="商品ID" :visible.sync="matchingShow" width="40%" append-to-body>
        <!-- 匹配 -->
        <div class="imgsel el-row margin-top1">
            <div class="el-col el-col-7 el-col-offset-1 margin-top1">
                <div class="imgurl">
                    <img :src="url" alt />
                </div>
                <div class="el-popover">
                    <img :src="url" alt />
                </div>
                <ul class="imglist margin-top1">
                    <li v-for="(item,index) in srcList" :key="index" @click="changeActive(item)">
                        <img :src="item" alt />
                    </li>
                </ul>
            </div>
            <div class="el-col el-col-15 el-col-offset-1">
                <div class="commodityt">
                    <p style="width: 100px; font-size: 20px;">商品名称</p>
                    <p style="font-size: 20px;">商品名称</p>
                </div>
                <div class="commodityt">
                    <p style="width: 100px;">原价</p>
                    <p>￥111</p>
                </div>
                <div class="commodityt">
                    <p style="width: 100px;">现价</p>
                    <p>￥123</p>
                </div>
                <div class="commodityt">
                    <p style="width: 100px;">尺码</p>
                    <div>
                        <el-button>xxs</el-button>
                        <el-button>xs</el-button>
                        <el-button>s</el-button>
                    </div>
                </div>
                <div class="commodityt">
                    <p style="width: 100px;">颜色</p>
                    <div>
                        <el-button>红</el-button>
                        <el-button>黄</el-button>
                        <el-button>蓝</el-button>
                    </div>
                </div>
                <div class="commodityt">
                    <p style="width: 100px;line-height: 40px;">数量</p>
                    <el-input-number v-model="num" @change="handleChange" label="描述文字"></el-input-number>
                </div>
                <div class="commodityt">
                    <el-button type="info" plain>立即匹配</el-button>
                    <el-button type="info" plain @click="addmatching">加入匹配</el-button>
                </div>
                <div class="commodityt">
                    <p style="width: 100px;">其他信息</p>
                    <div>
                        <span style="padding:15px;" v-for="(item,i) in Otherlist" :key="i">{{item}}</span>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: "FBMOrder",
    data() {
        return {
            radio: 0,
            value: "",
            matchingShow: false,
            textarea: "",
            num: "0",
            url:
                "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
            srcList: [
                "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
                "https://gd3.alicdn.com/imgextra/i3/266969832/O1CN01X7VRBQ2MV6gfqPnmI_!!266969832.jpg_400x400.jpg",
                "https://gd4.alicdn.com/imgextra/i2/266969832/O1CN012IEsit2MV6glnt2YR_!!266969832.jpg_400x400.jpg",
                "https://gd3.alicdn.com/imgextra/i3/266969832/O1CN01X7VRBQ2MV6gfqPnmI_!!266969832.jpg_400x400.jpg",
                "https://gd1.alicdn.com/imgextra/i1/266969832/O1CN019CeJTQ2MV6giioxH9_!!266969832.jpg_400x400.jpg",
                "https://gd2.alicdn.com/imgextra/i2/266969832/O1CN01UJseWI2MV6gZxYOVU_!!266969832.jpg_400x400.jpg",
                "https://gd3.alicdn.com/imgextra/i3/266969832/O1CN01clCQl22MV6ghy2TUk_!!266969832.jpg_400x400.jpg"
            ],
            input: "",
            Otherlist: ["普货", "带电", "带磁", "液体", "粉墨"]
        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        init() {
            this.matchingShow = true;
        },
        handleChange(value) {
            console.log(value);
        },
        addmatching() {
            this.$router.push({
                path: "/joinMatching/commoditieslist",
                name: "commoditieslist"
            });
        },
        changeActive(event) {
            this.url = event;
        }
    }
};
</script>
<style lang="scss">
.imgsel {
    position: relative;
    .el-icon-circle-close {
        color: #409eff;
    }
    .imgurl {
        width: 210px;
        height: 259px;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .imglist {
        li {
            width: 23%;
            height: 60px;
            float: left;
            margin-right: 2.3%;
            padding: 0 0 10px 0;
            img {
                width: 100%;
                height: 100%;
            }
        }
        li:nth-child(4n) {
            margin-right: 0;
        }
    }
    .imgurl:hover ~ .el-popover {
        display: block;
    }
    .el-popover {
        position: absolute;
        background: #fff;
        min-width: 150px;
        border: 1px solid #ebeef5;
        padding: 12px;
        z-index: 5000;
        left: 33%;
        right: 0%;
        top: -34%;
        color: #606266;
        line-height: 1.4;
        text-align: justify;
        font-size: 14px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        display: none;
        img {
            width: 90%;
        }
    }
    .commodityt {
        overflow: hidden;
        width: 100%;
        padding: 10px 0;
        p {
            font-size: 16px;
            display: block;
            float: left;
        }
        .el-input__inner {
            height: 40px;
        }
    }
}
</style>
